import { SxProps, Theme } from '@mui/material'

export const tabEditButtonSx: SxProps<Theme> = {
    position: 'absolute',
    right: 8,
    top: '50%',
    transform: 'translateY(-50%)',
    opacity: 0,
    pointerEvents: 'none',
    backgroundColor: 'transparent',
    color: 'inherit',
    minWidth: 'auto',
    padding: 0,

    '&:hover, &:active, &:focus, &.Mui-focusVisible, &.Mui-selected': {
        backgroundColor: 'transparent',
        outline: 'none',
    },
}
